var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"iconfont icon-arrow-left back",on:{"click":function($event){return _vm.$router.go(-1)}}}),_c('video',{attrs:{"src":_vm.src,"autoplay":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }